import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthDebugInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error?.status === 401 && this.isApiRequest(req.url)) {
          console.warn('[AuthDebug]', {
            url: req.url,
            method: req.method,
            hasAuthHeader: req.headers.has('Authorization'),
            status: error.status,
            error: error.error,
          });
        }

        return throwError(() => error);
      }),
    );
  }

  private isApiRequest(url: string): boolean {
    if (!url) return false;
    if (this.isRelativeUrl(url)) return true;

    const base = (environment.baseURL || '').trim().replace(/\/+$/, '');
    if (!base) return false;
    return url.startsWith(base);
  }

  private isRelativeUrl(url: string): boolean {
    return !/^https?:\/\//i.test(url);
  }
}
